import {connect} from '@modifi/redux'

import ConnectedSubmitButton from './ConnectedSubmitButton'
import {selectIsSubmitting, selectHasError} from '../../store'

const mapStateToProps = state => ({
  isSubmitting: selectIsSubmitting(state),
  hasError: selectHasError(state),
})

export default connect(mapStateToProps)(ConnectedSubmitButton)
